"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakpointAndDesktop = exports.breakpoint = void 0;

var _core = require("@emotion/core");

/** @jsx jsx */
var sizes = {
  base: 0,
  xs: 480,
  sm: 546,
  md: 768,
  lg: 948,
  xl: 1020
};
var breakpoint = Object.keys(sizes).reduce(function (acc, size) {
  acc[size] = function () {
    return (
      /*#__PURE__*/
      (0, _core.css)("@media (min-width:", sizes[size], "px){",
      /*#__PURE__*/
      _core.css.apply(void 0, arguments), "}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9taXhpbnMvYnJlYWtwb2ludHMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBYThCIiwiZmlsZSI6Ii4uLy4uL3NyYy9taXhpbnMvYnJlYWtwb2ludHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCwgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbmNvbnN0IHNpemVzID0ge1xuICBiYXNlOiAwLFxuICB4czogNDgwLFxuICBzbTogNTQ2LFxuICBtZDogNzY4LFxuICBsZzogOTQ4LFxuICB4bDogMTAyMCxcbn07XG5cbmV4cG9ydCBjb25zdCBicmVha3BvaW50ID0gT2JqZWN0LmtleXMoc2l6ZXMpLnJlZHVjZSgoYWNjLCBzaXplKSA9PiB7XG4gIGFjY1tzaXplXSA9ICguLi5hcmdzKSA9PiBjc3NgXG4gICAgQG1lZGlhIChtaW4td2lkdGg6ICR7c2l6ZXNbc2l6ZV19cHgpIHtcbiAgICAgICR7Y3NzKC4uLmFyZ3MpfVxuICAgIH1cbiAgYDtcblxuICByZXR1cm4gYWNjO1xufSwge30pO1xuXG5leHBvcnQgY29uc3QgYnJlYWtwb2ludEFuZERlc2t0b3AgPSBPYmplY3Qua2V5cyhzaXplcykucmVkdWNlKChhY2MsIHNpemUpID0+IHtcbiAgYWNjW3NpemVdID0gKC4uLmFyZ3MpID0+IGNzc2BcbiAgICBAbWVkaWEgKG1pbi13aWR0aDogJHtzaXplc1tzaXplXX1weCkge1xuICAgICAgJHtjc3MoLi4uYXJncyl9XG4gICAgfVxuXG4gICAgLmRlc2t0b3AgJiB7XG4gICAgICAke2NzcyguLi5hcmdzKX1cbiAgICB9XG4gIGA7XG5cbiAgcmV0dXJuIGFjYztcbn0sIHt9KTtcbiJdfQ== */"))
    );
  };

  return acc;
}, {});
exports.breakpoint = breakpoint;
var breakpointAndDesktop = Object.keys(sizes).reduce(function (acc, size) {
  acc[size] = function () {
    return (
      /*#__PURE__*/
      (0, _core.css)("@media (min-width:", sizes[size], "px){",
      /*#__PURE__*/
      _core.css.apply(void 0, arguments), "}.desktop &{",
      /*#__PURE__*/
      _core.css.apply(void 0, arguments), "}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9taXhpbnMvYnJlYWtwb2ludHMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBdUI4QiIsImZpbGUiOiIuLi8uLi9zcmMvbWl4aW5zL2JyZWFrcG9pbnRzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBqc3gsIGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuXG5jb25zdCBzaXplcyA9IHtcbiAgYmFzZTogMCxcbiAgeHM6IDQ4MCxcbiAgc206IDU0NixcbiAgbWQ6IDc2OCxcbiAgbGc6IDk0OCxcbiAgeGw6IDEwMjAsXG59O1xuXG5leHBvcnQgY29uc3QgYnJlYWtwb2ludCA9IE9iamVjdC5rZXlzKHNpemVzKS5yZWR1Y2UoKGFjYywgc2l6ZSkgPT4ge1xuICBhY2Nbc2l6ZV0gPSAoLi4uYXJncykgPT4gY3NzYFxuICAgIEBtZWRpYSAobWluLXdpZHRoOiAke3NpemVzW3NpemVdfXB4KSB7XG4gICAgICAke2NzcyguLi5hcmdzKX1cbiAgICB9XG4gIGA7XG5cbiAgcmV0dXJuIGFjYztcbn0sIHt9KTtcblxuZXhwb3J0IGNvbnN0IGJyZWFrcG9pbnRBbmREZXNrdG9wID0gT2JqZWN0LmtleXMoc2l6ZXMpLnJlZHVjZSgoYWNjLCBzaXplKSA9PiB7XG4gIGFjY1tzaXplXSA9ICguLi5hcmdzKSA9PiBjc3NgXG4gICAgQG1lZGlhIChtaW4td2lkdGg6ICR7c2l6ZXNbc2l6ZV19cHgpIHtcbiAgICAgICR7Y3NzKC4uLmFyZ3MpfVxuICAgIH1cblxuICAgIC5kZXNrdG9wICYge1xuICAgICAgJHtjc3MoLi4uYXJncyl9XG4gICAgfVxuICBgO1xuXG4gIHJldHVybiBhY2M7XG59LCB7fSk7XG4iXX0= */"))
    );
  };

  return acc;
}, {});
exports.breakpointAndDesktop = breakpointAndDesktop;